import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

var STORAGE_TOKEN_KEY = 'stmdesktoken'
var accessTokenStorage = {
  getToken: function () {
    var jToken = localStorage.getItem(STORAGE_TOKEN_KEY)
    var token = Object
    try {
      token = JSON.parse(jToken)
    } catch (err) {
      if (token === '' || token === undefined) {
        localStorage.setItem(STORAGE_TOKEN_KEY, { access_token: '' })
        return { access_token: '' }
      }
    }
    return token
  },
  setToken: function (token) {
    localStorage.setItem(STORAGE_TOKEN_KEY, JSON.stringify(token))
  }
}

var STORAGE_IS_LOGIN_KEY = 'stmdeskislogin'
var isLoginStorage = {
  get: function () {
    var t = localStorage.getItem(STORAGE_IS_LOGIN_KEY)
    if (!t) {
      this.set(false)
      t = false
      return t
    }
    if (t === 'true') return true
    else return false
  },
  set: function (token) {
    localStorage.setItem(STORAGE_IS_LOGIN_KEY, JSON.stringify(token))
  }
}

const state = {
  token: accessTokenStorage.getToken(),
  isLogin: isLoginStorage.get(),
  spinner: false
}

const getters = {
  getToken: state => {
    state.token = accessTokenStorage.getToken()
    return state.accessToken
  }
}

const mutations = {
  setToken (state, token) {
    state.token = token
    accessTokenStorage.setToken(token)
  },
  setIsLogin (state, isLogin) {
    state.isLogin = isLogin
    isLoginStorage.set(isLogin)
  },
  login (state, token) {
    state.token = token
    state.isLogin = true
    accessTokenStorage.setToken(token)
    isLoginStorage.set(true)
  },
  logout (state) {
    state.token = { access_token: '' }
    state.isLogin = false
    accessTokenStorage.setToken({ access_token: '' })
    isLoginStorage.set(false)
  },
  spinnerRun (state) {
    state.spinner = true
  },
  spinnerStop (state) {
    state.spinner = false
  }
}

export default new Vuex.Store({
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store.js